import { useDepartmentStore } from "@/features/department";
import { useSocialStudioStore } from "@/store/social-studio/useSocialStudioStore";
import { type DispatchContext } from "./types";
import { appEvents } from "@/shared/lib/events";

/** Returns true if the tool was handled. */
export function dispatchSocialTool(toolName: string, ctx: DispatchContext): boolean {
  const { payload } = ctx;
  const state = useDepartmentStore.getState();
  void state;

  switch (toolName) {
    case "start_social_research": {
      const brandId = useSocialStudioStore.getState().selectedBrandId ?? undefined;
      appEvents.publish({
        type: "agent-start-social-research",
        brandInput: payload.brandInput as unknown,
        ...(brandId ? { brandId } : {}),
      });
      return true;
    }
    case "send_to_production":
      appEvents.publish({
        type: "agent-send-to-production",
        detail: {
          briefId: payload.briefId,
          pipeline: payload.pipeline,
        },
      });
      return true;
    case "generate_template_preview":
      appEvents.publish({
        type: "agent-generate-template-preview",
        detail: {
          templateId: payload.templateId,
          aspectRatio: payload.aspectRatio,
          overlayText: payload.overlayText,
          userPrompt: payload.userPrompt,
        },
      });
      return true;
    case "generate_social_video":
      appEvents.publish({
        type: "agent-generate-social-video",
        detail: {
          source: payload.source,
          templateId: payload.templateId,
          briefId: payload.briefId,
          aspectRatio: payload.aspectRatio,
          prompt: payload.prompt,
          overlayText: payload.overlayText,
        },
      });
      return true;
    case "list_video_templates":
    case "list_generated_videos":
      return true;
    default:
      return false;
  }
}
